import React, { useEffect, useRef } from "react";
import { xs_languageCode } from "../..";
import { getStatsCoreConfigurationId, STATSCORE_WIDGET_PREMATCH_PRO } from "./WidgetContext";

const scriptToInject = `!function(){var d="STATSCOREWidgetsEmbederScript";if(!window.document.getElementById(d)){window.STATSCOREWidgets={},window.STATSCOREWidgets.onLoadCallbacks=[],window.STATSCOREWidgets.onLoad=function(d){window.STATSCOREWidgets.onLoadCallbacks.push(d)};var n=window.document.createElement("script");n.src="https://wgt-s3-cdn.statscore.com/bundle/Embeder.js",n.async=!0,n.id=d,n.addEventListener("error",function(d){for(var n=0;n<window.STATSCOREWidgets.onLoadCallbacks.length;n++)window.STATSCOREWidgets.onLoadCallbacks[n](d)}),window.document.body.appendChild(n)}}();`

function loadScript() {
    const id = "statsCoreWidgetScript";
    let script = document.getElementById(id);
    if (!script) {
        script = document.createElement('script');
        script.setAttribute("id", id)
        script.setAttribute("type", "text/javascript");
        script.innerHTML = scriptToInject;
        document.head.appendChild(script);
    }
}

function loadWidget(containerRef, widgetRef, eventId) {
    const groupId = getStatsCoreConfigurationId(STATSCORE_WIDGET_PREMATCH_PRO);

    const waitForSTATSCOREWidgets = setInterval(function () {
        if (window.STATSCOREWidgets == null) {
            return;
        }

        window.STATSCOREWidgets.onLoad(err => {
                if (err) {
                    switch (err.type) {
                        case 'NetworkError':
                            // Handle network error here
                            break;
                        case 'BrowserNotSupported':
                            // Handle unsupported browser here
                            break;
                        default:
                            throw new Error();
                    }
            
                    return;
                }
            
                // Input data for widget type you want to embded
                const inputData = { eventId: eventId, language: xs_languageCode.toLowerCase() };
            
                // Optional object with options.
                // You can check available options further in the docs.
                const options = {};
            
                widgetRef.current = new window.STATSCOREWidgets.WidgetGroup(containerRef.current, groupId, inputData, options);
            });
            clearInterval(waitForSTATSCOREWidgets);
    }, 100);
    
}

function destroyWidget(widgetRef) {
    if (widgetRef.current) {
        widgetRef.current.destroy();
    }
}

export default function PrematchProWidget(props) {
    const containerRef = useRef(null);
    const widget = useRef(null);
    const eventId = props.id;

    useEffect(() => {
        destroyWidget(widget);
        if (props.id && props.id != 0) {
            loadWidget(containerRef, widget, eventId);
        }
    }, [props.id]);

    useEffect(() => {
        loadScript();

        return () => destroyWidget(widget);
    }, []);

    return (
        <>
            <div ref={containerRef} id="prematchProWidgetContainer"></div>
        </>
    );
}
